// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /member/get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeMemberGetBody,
  typeMemberGetOutput200,
} from "../../sdk/member/postMemberGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildMemberGetQueryKey(payload: typeMemberGetBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`targetUserId:${JSON.stringify(payload.targetUserId)}`);
  return ["post:member:memberGet", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeMemberGetOutput200,
    unknown,
    typeMemberGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useMemberGet(
  payload: typeMemberGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildMemberGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postMemberGet(payload),
    ...resolvedOptions,
  });
}
